// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_base_nav__up_HI","utilityLink":"styles_base_utilityLink__MpgL8","countryLabel":"styles_base_countryLabel__aLzI9","countryIcon":"styles_base_countryIcon___SYRp"};